import { render, staticRenderFns } from "./xiangqing.vue?vue&type=template&id=ceb21a96&scoped=true"
import script from "./xiangqing.vue?vue&type=script&lang=js"
export * from "./xiangqing.vue?vue&type=script&lang=js"
import style0 from "./xiangqing.vue?vue&type=style&index=0&id=ceb21a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb21a96",
  null
  
)

export default component.exports